// extracted by mini-css-extract-plugin
export default {"actions":"StudioEmail_actions__FgrmY","loader_wrap":"StudioEmail_loader_wrap__38H20","Studio_Social_Media_inputs":"StudioEmail_Studio_Social_Media_inputs__-rbB6"};